module.exports = __webpack_public_path__ + "static/media/Gilroy-Light.25e5ce97.ttf";